export enum CTAURLResourceEnum{
    SIM = '/it/prenotaeritiraform/',
    SMARTPHONE = "/it/prenotaeritiraformsmartphone/",
    FISSA_APPUNTAMENTO = "/it/fissappuntamentoform/"  
}